export default __webpack_public_path__ + "static/media/mail.9a1c40a9.png";